import React, {use, createContext, useState} from "react";
import PropTypes from "prop-types";
import {useListData} from "../hooks/useListData";
import {useMediaQuery} from "@mui/material";
import {smallDeviceWidth} from "../../../resources/theme";
import {useRegScoutCore} from "../../../resources/RegScoutCoreProvider";
import {isNull} from "underscore";

const RegulationsDataContext = createContext({});
const RegulationsLayoutContext = createContext({});

export const RegulationsProvider = ({children}) => {
  const {isPlatform} = useRegScoutCore();
  const hideFilterBar = isNull(isPlatform);
  const isSmallDevice = useMediaQuery(
      `(max-device-width: ${smallDeviceWidth})`,
  );

  const [sidebarOpen, setSidebarOpen] = useState(
    hideFilterBar ? !isSmallDevice : !isPlatform,
  );
  const [hideFilteredItems, setHideFilteredItems] = useState(false);
  const [mapOpen, setMapOpen] = useState(false);
  const [mapInView, setMapInView] = useState("world");
  const [useRiskMapOverlay, setUseRiskMapOverlay] = useState(true);

  const {
    regulationsListData,
    listQueryLoading,
    allRegulations,
    allRegulationTypes,
    currentSort,
    setCurrentSort,
    areFiltersActive,
    clearFilters,
    currentFilters,
    setCurrentFilters,
    tagTypeOptions,
    tagTypeData,
  } = useListData();

  return (
    <RegulationsDataContext
      value={{
        regulationsListData,
        listQueryLoading,
        allRegulations,
        allRegulationTypes,
        currentSort,
        setCurrentSort,
        areFiltersActive,
        clearFilters,
        currentFilters,
        setCurrentFilters,
        tagTypeOptions,
        tagTypeData,
        hideFilteredItems,
        setHideFilteredItems,
      }}
    >
      <RegulationsLayoutContext
        value={{
          sidebarOpen,
          setSidebarOpen,
          mapOpen,
          setMapOpen,
          mapInView,
          setMapInView,
          useRiskMapOverlay,
          setUseRiskMapOverlay,
        }}
      >
        {children}
      </RegulationsLayoutContext>
    </RegulationsDataContext>
  );
};

RegulationsProvider.propTypes = {
  activeTheme: PropTypes.object,
  children: PropTypes.any,
};

export const useRegulationsData = () => {
  return use(RegulationsDataContext);
};

export const useRegulationsLayout = () => {
  return use(RegulationsLayoutContext);
};
